import { inject } from '@angular/core'
import { CanMatchFn, Router } from '@angular/router'
import { filter, map, Observable, switchMap, tap } from 'rxjs'
import { UserDomain } from '../../shared/domain/user.domain'
import { AuthDomain } from '../../shared/domain/auth.domain'

export function profilGuard(): CanMatchFn {
  return (): Observable<boolean> => {
    const userDomain: UserDomain = inject(UserDomain)
    const authDomain: AuthDomain = inject(AuthDomain)
    const router = inject(Router)

    return authDomain.isAuthenticated$.pipe(
      filter((isAuthenticated) => isAuthenticated),
      switchMap(() => {
        if (!userDomain.connectedUser()) {
          userDomain.loadConnectedUser().subscribe()
        }
        return userDomain.connectedUser$.pipe(
          filter((user) => !!user),
          tap((user) => {
            if (!user.accesApplicatif?.length) {
              router.navigate(['/user-not-authenticated'])
            }
          }),
          map(() => true),
        )
      })
    )
  }
}
